import React from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  RedditShareButton,
  EmailShareButton,
  PinterestShareButton,
} from "react-share";

import ShareVisual from "../../../assets/blog/share.webp";

export default function Share({ url, title, image }) {
  const imageUrl = image;
  return (
    <div className="row mt-3">
      {/* Share Buttons */}
      <div className="col-6 col-md-3 d-flex justify-content-center mb-3">
        <FacebookShareButton url={url} quote={title} className="w-100">
          <button className="btn btn-primary w-100">
            <i className="bi bi-facebook"></i> Facebook
          </button>
        </FacebookShareButton>
      </div>
      <div className="col-6 col-md-3 d-flex justify-content-center mb-3">
        <TwitterShareButton url={url} title={title} className="w-100">
          <button className="btn btn-info w-100">
            <i className="bi bi-twitter"></i> Twitter
          </button>
        </TwitterShareButton>
      </div>
      <div className="col-6 col-md-3 d-flex justify-content-center mb-3">
        <LinkedinShareButton url={url} title={title} className="w-100">
          <button className="btn btn-secondary w-100">
            <i className="bi bi-linkedin"></i> LinkedIn
          </button>
        </LinkedinShareButton>
      </div>
      <div className="col-6 col-md-3 d-flex justify-content-center mb-3">
        <EmailShareButton
          url={url}
          subject={title}
          body={url}
          className="w-100"
        >
          <button className="btn btn-outline-dark w-100">
            <i className="bi bi-envelope"></i> Email
          </button>
        </EmailShareButton>
      </div>
      <div className="col-6 col-md-3 d-flex justify-content-center mb-3">
        <WhatsappShareButton
          url={url}
          title={title}
          separator=" "
          className="w-100"
        >
          <button className="btn btn-success w-100">
            <i className="bi bi-whatsapp"></i> WhatsApp
          </button>
        </WhatsappShareButton>
      </div>
      <div className="col-6 col-md-3 d-flex justify-content-center mb-3">
        <TelegramShareButton url={url} title={title} className="w-100">
          <button
            className="btn btn-primary w-100"
            style={{ backgroundColor: "#0088cc", borderColor: "#0088cc" }}
          >
            <i className="bi bi-telegram"></i> Telegram
          </button>
        </TelegramShareButton>
      </div>
      <div className="col-6 col-md-3 d-flex justify-content-center mb-3">
        <RedditShareButton url={url} title={title} className="w-100">
          <button className="btn btn-danger w-100">
            <i className="bi bi-reddit"></i> Reddit
          </button>
        </RedditShareButton>
      </div>
      <div className="col-6 col-md-3 d-flex justify-content-center mb-3">
        <PinterestShareButton
          url={url}
          media={imageUrl}
          description={title}
          className="w-100"
        >
          <button className="btn btn-danger w-100">
            <i className="bi bi-pinterest"></i> Pinterest
          </button>
        </PinterestShareButton>
      </div>
      <img
        src={ShareVisual}
        alt="Share"
        style={{
          width: 200,
          height: "auto",
          objectFit: "cover",
        }}
      />
    </div>
  );
}
